import { Search } from '@h2oai/ui-kit';
import { useState } from 'react';

import { useTimeFilters } from './common/hooks';
import { formatDateLocal } from './common/utils';
import { searchStyle, tableAreaStyle } from './components/AppEvent/AppEvent.styles';
import InstanceTable from './components/AppEvent/InstanceTable/InstanceTable';
import TimeFilters from './components/TimeFilters/TimeFilters';
import PageWrapper from './PageWrapper';

export default function InstanceEvent() {
  const [searchQuery, setSearchQuery] = useState('');
  const { startDate, endDate, selectedTimeFrame, handleTimeFilterChange } = useTimeFilters();

  return (
    <PageWrapper>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginBottom: '2rem',
        }}
      >
        <Search
          emptyMessage="No results found"
          placeholder="Search events..."
          onSearchTextChange={(text: string) => setSearchQuery(text)}
          style={searchStyle}
        />
        <TimeFilters
          startDate={startDate}
          endDate={endDate}
          selectedTimeFrame={selectedTimeFrame}
          onChange={handleTimeFilterChange}
        />
      </div>
      <div style={tableAreaStyle}>
        <InstanceTable
          startDate={formatDateLocal(startDate)}
          endDate={formatDateLocal(endDate)}
          searchQuery={searchQuery}
        />
      </div>
    </PageWrapper>
  );
}
